import React from "react";
import "./Footer.css";
import { Grid, Row, Col } from "react-bootstrap";
import goFurther from "../../assets/footer/logo.png";
import {
  Facebook,
  Twitter,
  Instagram
} from "../General/Svgs/SVGs";
import { prefix } from "../../scripts/helpers/constants";

const footer = props => {
  return (
    <footer className={prefix + "-c-footer"}>
      <Grid fluid={true} className="no-padding">
        <Row className="no-margin footer-body">

          <Col
            xs={12}
            className="no-padding footer-body-section-image"
          >
            <img src={goFurther} alt="goFurther" className="center-block" />
          </Col>

          <Col
            xs={12}
            className="no-padding footer-body-section-social"
          >
            <Row className="no-margin">
              <Col className="footer-body-section-social">
                <div className="footer-body-section-social-sub">
                  <a
                    className="footer-share-icons-link"
                    target="_blank"
                    href={props.reference.facebook}
                  >
                    <Facebook reference="svg-icon footer-share-icons" />
                  </a>
                  <a
                    className="footer-share-icons-link"
                    target="_blank"
                    href={props.reference.twitter}
                  >
                    <Twitter reference="svg-icon footer-share-icons" />
                  </a>
                  <a
                    className="footer-share-icons-link"
                    target="_blank"
                    href={props.reference.instagram}
                  >
                    <Instagram reference="svg-icon footer-share-icons" />
                  </a>
                </div>
              </Col>
            </Row>
          </Col>

          <Col
            xs={12}
            className="no-padding footer-body-section-content"
          >
            <p className="p3">
              <a
                target="_blank"
                href={props.data.terms}
                className="footer-terms"
              >
                {props.content.terms}
              </a>{" "}
              |{" "}
              <a
                target="_blank"
                href={props.data.policy}
                className="footer-privacy"
              >
                {props.content.privacy}
              </a>
            </p>
          </Col>

        </Row>
      </Grid>
    </footer>
  );
};

export default footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js